module.exports = __webpack_public_path__ + "static/material-spandex.2ea30ca9.svg";